import React from 'react'

function RightSide() {
    return (
        <aside className="right">
            <div className="name">
                <a href="mailto:brianmauriceoluoch@gmail.com">
                <h3>brianmauriceoluoch@gmail.com</h3>
                </a>
                <div className="line"></div>
            </div>
        </aside>
    )
}

export default RightSide
